var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProfileIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5C8.34 0.5 0.5 8.34 0.5 18C0.5 27.66 8.34 35.5 18 35.5C27.66 35.5 35.5 27.66 35.5 18C35.5 8.34 27.66 0.5 18 0.5ZM18 5.75C20.905 5.75 23.25 8.095 23.25 11C23.25 13.905 20.905 16.25 18 16.25C15.095 16.25 12.75 13.905 12.75 11C12.75 8.095 15.095 5.75 18 5.75ZM18 30.6C13.625 30.6 9.7575 28.36 7.5 24.965C7.5525 21.4825 14.5 19.575 18 19.575C21.4825 19.575 28.4475 21.4825 28.5 24.965C26.2425 28.36 22.375 30.6 18 30.6Z",
    fill: "#C0C0C0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfileIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ProfileIcon.22baa2d5.svg";
export { ForwardRef as ReactComponent };